// sapJob.js
// -----------------------------------------------------------------------------
// The ASMX calls ส่งเข้าจัดรถ (and ยกเลิกการส่ง) make, in one place: the same
// endpoints and payloads คิวรถเล็ก's confirm and managecar use. The view calls
// these between the service's transactions; services never touch the network.
// Every failure throws (or returns null for "not found") -- the caller reports
// it, never retries silently.
// -----------------------------------------------------------------------------
import axios from 'axios'

const url = (webPath, endpoint) => `${webPath}deliveryWebService.asmx/${endpoint}`
const parse = res => JSON.parse(res.data.d)

async function readSo (webPath, soNo) {
  const rows = parse(await axios.post(url(webPath, 'GetSo'), { so: soNo }))
  return (rows && rows[0]) || null
}

async function readProducts (webPath, soNo) {
  const rows = parse(await axios.post(url(webPath, 'GetProdList'), { so: soNo }))
  if (!rows || !rows.length) throw new Error('NO_PRODUCTS')
  return rows
}

async function readPayment (webPath, typePayment) {
  if (!typePayment) return ''
  try {
    const rows = parse(await axios.post(url(webPath, 'GetPayment'), { typePayment }))
    return (rows[0] && rows[0].payment) || ''
  } catch (e) {
    return ''
  }
}

async function readRt (webPath, rtNo) {
  const rows = parse(await axios.post(url(webPath, 'GetRT'), { rtNo: Number(rtNo) }))
  const rt = rows && rows[0]
  if (!rt) return null
  const items = parse(await axios.post(url(webPath, 'GetRtProdList'), { docEntry: rt.docEntry }))
  return { rt, rows: items || [] }
}

async function updateSo (webPath, payload) {
  const res = await axios.post(url(webPath, 'UpdateSo'), JSON.stringify(payload),
    { headers: { 'Content-Type': 'application/json; charset=utf-8' }, timeout: 10000 })
  if (!res.data || res.data.d !== 'true') throw new Error('UpdateSo')
}

async function updateRt (webPath, payload) {
  const res = await axios.post(url(webPath, 'UpdateRT'), payload, { timeout: 10000 })
  const d = res && res.data && res.data.d
  if (d !== 'true' && d !== 'Success') throw new Error('UpdateRT')
}

async function cancelSo (webPath, soNo) { await axios.post(url(webPath, 'CancelSo'), { soNo }) }
async function cancelRt (webPath, rtNo) { await axios.post(url(webPath, 'CancelRt'), { rtNo }) }

async function lastTransNo (webPath) {
  const last = parse(await axios.post(url(webPath, 'GetTransNoLast'), {})).transNoLast
  return last ? parseInt(String(last).replace(/\D/g, ''), 10) || 0 : 0
}

async function drivers (webPath) {
  const rows = parse(await axios.post(url(webPath, 'GetDriver'), {}))
  return (rows || []).map(r => r.driverCode + ' - ' + r.driverDesc)
}

export default { readSo, readProducts, readPayment, readRt, updateSo, updateRt, cancelSo, cancelRt, lastTransNo, drivers }
